<dx-data-grid
    #dataGrid
    bds-grid
    id="bdsRouteSegmentGrid"
    [dataSource]="dataSource"
    [columns]="displayColumns"
    height="35vh"
    minHeight="200px"
    [(selectedRowKeys)]="selectedRowKeys"
    [bdsAllowAddRecord]="!readOnly"
    [bdsAllowDeleteRecords]="!readOnly"
    [bdsAllowAddRecord]="false"
    [bdsAllowDeleteRecords]="false"
    [bdsFastracVisible]="false"
    [bdsUseFastrac]="false"
    [needsRefresh]="false"
    (onRowUpdating)="onRowUpdating($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)"
    (onEditCanceled)="onEditCanceled()"
>
    <dxo-editing mode="cell" [allowUpdating]="!readOnly"></dxo-editing>
    <!-- <dxi-column dataField="segmentNo" caption="Segment No."></dxi-column> -->
    <dxi-column
        dataField="contractNo"
        caption="Contract No."
        [allowEditing]="!readOnly"
    ></dxi-column>
    <dxi-column dataField="railroad" caption="Railroad" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="junction" caption="Rule 260" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="splcErpc.city" caption="ERPC City" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="splcErpc.state" caption="ERPC State" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="beginSplc" caption="Junction SPLC" [allowEditing]="false"></dxi-column>
    <dxi-column
        dataField="benchmarkHours"
        caption="Benchmark Hours"
        [allowEditing]="!readOnly"
    ></dxi-column>
    <dxi-column
        dataField="mileageAllowanceIndicator"
        caption="Segment Miles"
        [allowEditing]="false"
    ></dxi-column>
    <dxi-column
        dataField="segmentMiles.weightLimit"
        caption="Weight Limit"
        [allowEditing]="false"
    ></dxi-column>
    <dxi-column
        dataField="segmentMiles.isActive"
        caption="Active Status"
        [allowEditing]="false"
    ></dxi-column>
</dx-data-grid>
